(()=>{'use strict';
 const instances=new WeakMap();
 function init(root){
  if(instances.has(root))return;
  const slides=[...root.querySelectorAll('[data-home-slide]')],controls=root.querySelector('[data-home-controls]'),dots=[...root.querySelectorAll('[data-home-index]')],arrows=[...root.querySelectorAll('[data-home-direction]')],pause=root.querySelector('[data-home-pause]'),motion=matchMedia('(prefers-reduced-motion: reduce)');
  if(slides.length<2||!controls||!pause)return;
  let index=0,paused=motion.matches,visible=false,hovered=false,focused=false,cycleReady=false,timer,disposed=false;
  const abort=new AbortController(),on=(node,type,fn)=>node.addEventListener(type,fn,{signal:abort.signal});
  const canMove=()=>!disposed&&!paused&&!motion.matches&&visible&&!hovered&&!focused&&!document.hidden;
  function label(){pause.textContent=paused?'▶':'Ⅱ';pause.setAttribute('aria-label',paused?pause.dataset.play:pause.dataset.pause);root.dataset.paused=String(paused);}
  function hydrate(slide){
   const template=slide.querySelector('[data-home-deferred]');
   if(template){template.replaceWith(template.content.cloneNode(true));slide.dataset.loaded='true';}
  }
  function schedule(){
   clearTimeout(timer);
   if(!canMove())return;
   if(index===0){if(cycleReady)timer=setTimeout(()=>show(1),80);}
   else timer=setTimeout(()=>show(0),12000);
  }
  function show(next){
   next=(next+slides.length)%slides.length;
   if(disposed||next===index)return;
   index=next;hydrate(slides[index]);
   slides.forEach((slide,i)=>{slide.hidden=i!==index;slide.inert=i!==index;slide.setAttribute('aria-hidden',String(i!==index));});
   dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===index)));
   root.dataset.active=String(index);cycleReady=false;
   root.dispatchEvent(new CustomEvent('mt:hero-slide-change',{detail:{index}}));
   schedule();
  }
  function manual(next){paused=true;label();show(next);schedule();}
  dots.forEach((dot,i)=>on(dot,'click',()=>manual(i)));
  arrows.forEach(arrow=>on(arrow,'click',()=>manual(index+Number(arrow.dataset.homeDirection))));
  on(pause,'click',()=>{paused=!paused;label();schedule();});
  on(root,'mt:hero-cycle-complete',()=>{if(index!==0)return;cycleReady=true;schedule();});
  on(root,'mouseenter',()=>{hovered=true;schedule();});on(root,'mouseleave',()=>{hovered=false;schedule();});
  on(root,'focusin',()=>{focused=true;schedule();});
  on(root,'focusout',()=>requestAnimationFrame(()=>{if(disposed)return;focused=root.contains(document.activeElement);schedule();}));
  on(document,'visibilitychange',schedule);
  on(motion,'change',()=>{if(motion.matches){paused=true;label();}schedule();});
  const observer=typeof IntersectionObserver==='function'?new IntersectionObserver(([entry])=>{visible=entry.isIntersecting;schedule();},{threshold:.15}):null;
  if(observer)observer.observe(root);else visible=true;
  slides.forEach((slide,i)=>{slide.hidden=i!==0;slide.inert=i!==0;slide.setAttribute('aria-hidden',String(i!==0));});
  controls.hidden=false;arrows.forEach(arrow=>arrow.hidden=false);root.dataset.active='0';root.dataset.ready='true';label();schedule();
  instances.set(root,()=>{disposed=true;clearTimeout(timer);abort.abort();observer?.disconnect();instances.delete(root);delete root.dataset.ready;});
 }
 const within=(scope,fn)=>{if(scope.matches?.('[data-home-reel]'))fn(scope);scope.querySelectorAll?.('[data-home-reel]').forEach(fn);};
 within(document,init);
 document.addEventListener('shopify:section:load',event=>within(event.target,init));
 document.addEventListener('shopify:section:unload',event=>within(event.target,root=>instances.get(root)?.()));
})();
